import script from "./CoursesHome.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursesHome.vue?vue&type=script&setup=true&lang=js"

import "./CoursesHome.vue?vue&type=style&index=0&id=6c2a6986&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c2a6986"]])

export default __exports__